import styled from 'styled-components';
import { ImageUtils } from '../../utils/ImageUtils';
import { TicketNumberType } from '../../store/infoStore';
import dayjs from 'dayjs';
import { SHOW_QR_DATE } from '../../hook/useDateHook';

export const NumberTicket = ({ cnt }: { cnt: TicketNumberType }) => {
  return (
    <TicketContainer>
      <Ticket src={ImageUtils.Card} />
      <TicketTextContainer>
        <Inner>
          <Title>오프라인 메인 이벤트 참가 정보</Title>
          <NumberTitleContainer>
            <NumberTitle>참가자 번호</NumberTitle>
          </NumberTitleContainer>
          <TicketText>{cnt.ticketNo}</TicketText>
          <WaringTextContainer>
            <WaringText>
              QR코드는 {dayjs(SHOW_QR_DATE).add(1, 'seconds').format('M월 D일 HH시')} 부터
              보여집니다.
            </WaringText>
          </WaringTextContainer>
        </Inner>
      </TicketTextContainer>
    </TicketContainer>
  );
};

const Title = styled.h3`
  font-weight: 800;
  text-align: center;
  letter-spacing: -0.02em;

  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 9px;

  margin-top: 0;
  font-size: 16px;
  line-height: 16px;
`;

const NumberTitleContainer = styled.div`
  margin: 0 auto;

  background: rgba(0, 0, 0, 0.1);
  border-top: 1px solid #000000;

  width: 215px;
  height: 32px;
`;

const NumberTitle = styled.h4`
  font-weight: 800;
  text-align: center;
  letter-spacing: -0.02em;
  color: #000000;

  font-size: 16px;
  line-height: 29px;
`;

const WaringTextContainer = styled.div`
  text-align: center;
`;

const WaringText = styled.p`
  font-weight: 600;
  text-align: center;

  color: rgba(0, 0, 0, 0.6);
  border-top: 1px solid rgba(0, 0, 0, 0.6);
  display: inline-block;

  font-size: 12px;
  line-height: 16px;
  padding-top: 5px;
`;

const Ticket = styled.img`
  position: relative;
`;

const TicketContainer = styled.div`
  display: flex;
  position: relative;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const TicketTextContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Inner = styled.div``;

const TicketText = styled.p`
  font-weight: bold;
  font-weight: 700;
  color: #000000;
  text-align: center;

  font-size: 86px;
  line-height: 90px;
  padding-bottom: 10px;
`;
